export default "__VITE_ASSET__YzVGl6A2__"